import { FC } from 'react';
import DoctorDropdown from './DoctorDropdown';

interface InNetworkDoctorDropdownProps {
  insuranceId: string;
  selectedDoctorIds: string[];
  disabledDoctorIds: string[];
  disabled?: boolean;
}

const InNetworkDoctorDropdown: FC<InNetworkDoctorDropdownProps> = ({
  insuranceId,
  selectedDoctorIds,
  disabledDoctorIds,
  disabled,
}) => {
  return (
    <DoctorDropdown
      insuranceId={insuranceId}
      selectedDoctorIds={selectedDoctorIds}
      isInNetwork={true}
      disabledDoctorIds={disabledDoctorIds}
      disabled={disabled}
    />
  );
};

export default InNetworkDoctorDropdown;